import config from '@/config';

/**
 * API Endpoints Registry
 *
 * Central registry for all backend API base URLs.
 * Easy to update/replace in the future (e.g., API gateway consolidation).
 *
 * Usage in RTK Query endpoints:
 * ```typescript
 * getRecipes: builder.query({
 *   query: () => ({ url: 'recipes', endpoint: 'transformer' }),
 * }),
 * ```
 */
export const API_ENDPOINTS = {
  /** Main DataProtect API - applications, users, tenants, etc. */
  main: () => config.API_URL,

  /** Transformer/workflow engine API */
  transformer: () => config.TRANS_API_URL,

  /** Job monitoring API */
  monitor: () => config.MONITOR_API_URL,

  /** Salesforce integration agent API */
  sfAgent: () => config.SF_AGENT_API_URL,

  /** Data operations API */
  data: () => config.DATA_API_URL,

  /** External data operations API */
  extData: () => config.EXT_DATA_API_URL,

  /** Connection testing API */
  testConn: () => config.TEST_CONN_API_URL,
} as const;

export type ApiEndpoint = keyof typeof API_ENDPOINTS;

/**
 * Get the base URL for a specific API endpoint
 */
export function getApiBaseUrl(endpoint: ApiEndpoint): string {
  return API_ENDPOINTS[endpoint]();
}
